import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ModalFormSection, ModalV2 } from 'components/common/modals';
import { Link } from 'components/common/ui';
import { showError } from '@utils';
import { agentsServices } from '@services';
import { useAssignees, useToggleModal } from '@hooks';
import AddAgentModalForm from '../AddAgentModal/AddAgentModalForm';
import { rolesOptions } from '../rolesOptions';

const EditAgentModal = ({ getAgents, agent }) => {
  const { invalidateAssignees } = useAssignees();
  const { isOpen, handleOpen, handleClose } = useToggleModal();
  const [isLoading, setIsLoading] = useState();
  let { user } = localStorage;
  if (user) {
    user = JSON.parse(user);
  }

  const handleSubmit = async (data = {}) => {
    try {
      setIsLoading(true);
      const payload = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        role: data.role?.value,
        isActive: data.isActive,
        userName: data.userName,
        emailSignature: data.emailSignature,
      };

      await agentsServices.editAgent(agent?.id, payload);
      invalidateAssignees();
      await getAgents();
      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const role = rolesOptions.find((item) => item.value === agent?.role);

  const defaultValues = {
    ...agent,
    role: { ...role, text: role.label },
  };

  return (
    <>
      <Box color="primary" onClick={handleOpen}>
        <Link text={agent?.id} />
      </Box>
      {isOpen && (
        <ModalV2
          id="edit-agent"
          title="Edit Agent"
          isOpen={isOpen}
          onClose={handleClose}
          maxWidth="sm"
        >
          <ModalFormSection>
            <AddAgentModalForm
              defaultValues={defaultValues}
              onSubmit={handleSubmit}
              onClose={handleClose}
              isLoading={isLoading}
            />
          </ModalFormSection>
        </ModalV2>
      )}
    </>
  );
};

export default EditAgentModal;
